module.exports = __webpack_public_path__ + "static/media/SFC Color.6c228809.png";